var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgConverterD(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 5H5.5V4H8.5V5ZM6.5 7H5.5V12H6.5V7ZM7.5 12H8.5V7H7.5V12ZM12.5 5V11H14.5V12L12.5 13V15L11.5 16H3.5L2.5 15V13L0.5 12V11H2.5V5H0.5V4L2.5 3V1L3.5 0H11.5L12.5 1V3L14.5 4V5H12.5ZM10.5 2H4.5V14H10.5V2Z",
    fill: "#464646"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConverterD);
export default __webpack_public_path__ + "static/media/converter_d.bb0be9543f0fa0c1bb4c0577a11f5c69.svg";
export { ForwardRef as ReactComponent };